import { Fragment } from "react";
import { Link } from "react-router-dom";
import Alert from "../../components/Alerts/Alert";
import { useTranslation } from "react-i18next";

const Error = (props: { message: string }) => {
    const { t } = useTranslation();

    return (
        <Fragment>
            <h2 className="mb-7 ta-c">{t("result.errorTitle")}</h2>
            <p className="ta-c">{t("result.errorDescription")}</p>
            <Alert message={props.message} />
            <Link to="/" className="secondary-button mt-7">{t("result.back")}</Link>
        </Fragment>
    );
};

export default Error;
